import { render, staticRenderFns } from "./s-gongl-pop.vue?vue&type=template&id=0f5d25a4&scoped=true&"
import script from "./s-gongl-pop.vue?vue&type=script&lang=js&"
export * from "./s-gongl-pop.vue?vue&type=script&lang=js&"
import style0 from "./s-gongl-pop.vue?vue&type=style&index=0&id=0f5d25a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5d25a4",
  null
  
)

export default component.exports